import * as React from 'react';
import { useContext } from 'react';
import CalendarModuleProps from './type';
import PageHeader from '../../components/PageHeader';
import CompetitionCarousel from '../../components/CompetitionCarousel';
import FeaturedCompetitionsList from '../../components/FeaturedCompetitionsList';
import Calendar from '../../components/Calendar';
import Tabs, { Tab, TabPanel } from '../../components/common/Tabs';
import LocalizationContext from '../../contexts/Localizations';
import { resetQueryString } from './methods';
import './styles.scss';

const CalendarModule = ({
  filters,
  disciplineCode,
  disciplineColourCode,
  featuredCompetitionLinks,
  header,
  carousel,
  bearerToken,
}: CalendarModuleProps) => {
  const { translations } = useContext(LocalizationContext);

  const hasCards = (carousel?.latest)
    || (carousel?.upcoming?.length ?? 0) > 0
    || (carousel?.live?.length ?? 0) > 0;

  return (
    <section className={`
      calendar-module
      page-template
      ${disciplineCode ? `calendar-module--${disciplineColourCode}` : ''}
      ${carousel ? 'calendar-module--has-carousel' : ''}
      ${!featuredCompetitionLinks?.length ? 'calendar-module--no-featured-items' : ''}
    `}
    >
      {header && (
        <div className="calendar-module__header">
          <PageHeader {...header} />

          {Boolean(carousel) && (
            <div
              className={`calendar-module__carousel-container ${
                hasCards ? '' : 'calendar-module__carousel-container--empty'
              }`}
            >
              <div className="calendar-module__upcoming-carousel">
                <CompetitionCarousel cards={carousel} themeColor="transparentDark" />
              </div>
            </div>
          )}
        </div>
      )}

      {Boolean(featuredCompetitionLinks?.length) && (
        <div className="calendar-module__featured-competitions-list">
          <FeaturedCompetitionsList
            links={featuredCompetitionLinks?.length ? featuredCompetitionLinks : []}
            discipline={disciplineColourCode}
            viewMoreLabel={translations.calendar.viewMoreLabel}
          />
        </div>
      )}

      <Tabs changeTabCallBack={resetQueryString} isCalendar>

        <Tab
          key="calendar-upcoming"
          id="calendar-upcoming"
          label={translations.calendar.upcomingLabel}
        />
        <Tab
          key="calendar-past"
          id="calendar-past"
          label={translations.calendar.pastLabel}
        />

        <TabPanel key="panel-calendar-upcoming" tabId="calendar-upcoming">
          <Calendar
            filters={filters}
            disciplineCode={disciplineCode}
            bearerToken={bearerToken}
            allowMultipleSelection
            calendarDownloadOptions="Current and Next"
          />
        </TabPanel>

        <TabPanel key="panel-calendar-past" tabId="calendar-past">
          <Calendar
            filters={filters}
            disciplineCode={disciplineCode}
            bearerToken={bearerToken}
            isPast
            allowMultipleSelection
            calendarDownloadOptions="Current and Next"
          />
        </TabPanel>
      </Tabs>
    </section>
  );
};

export default CalendarModule;
